import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Info } from "lucide-react";

export const GLOSSARY = {
  RSI: {
    term: "RSI · Relative Strength Index",
    body: "A 0–100 momentum gauge of how fast and far price has moved recently. Above 70 is 'overbought' (may be stretched), below 30 is 'oversold'. We use it as a guardrail, not a buy signal.",
  },
  SMA: {
    term: "SMA · Simple Moving Average",
    body: "The average closing price over a set number of days (we use 20 and 50). When price sits above rising averages, it points to an uptrend; below them, a downtrend.",
  },
  ATR: {
    term: "ATR · Average True Range",
    body: "A volatility measure — the typical daily price swing. Shown as a % of price: higher ATR% means bigger swings and a higher risk tier.",
  },
  Momentum: {
    term: "Momentum",
    body: "How much the price has changed over roughly the last 20 trading days. Strong positive momentum can indicate a trend with wind at its back.",
  },
};

export function InfoTip({ term, className = "" }) {
  const g = GLOSSARY[term];
  if (!g) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`glossary-${term}`} aria-label={`What is ${term}?`}
          onClick={(e) => e.stopPropagation()}
          className={`inline-flex items-center justify-center h-5 w-5 rounded-full text-muted-foreground hover:text-primary hover:bg-primary/10 transition-colors ${className}`}>
          <Info className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" align="start" className="w-72 text-sm" onClick={(e) => e.stopPropagation()}>
        <p className="font-semibold mb-1">{g.term}</p>
        <p className="text-muted-foreground leading-relaxed text-xs">{g.body}</p>
      </PopoverContent>
    </Popover>
  );
}
